const SERVICES = [
  {
    title: "Land Surveying",
    desc: "Boundary retracement, ALTA/NSPS land title surveys, topographic contours, construction stakeout, and as-built verification.",
    tag: "Licensed PS / RLS"
  },
  {
    title: "Stormwater & Civil",
    desc: "Detention/retention basin design, hydraulic & hydrologic calculations, site grading, utility layout, and SWP3 plans.",
    tag: "Licensed PE"
  },
  {
    title: "Subsurface Utilities",
    desc: "SUE investigation Quality Levels C through A. Vacuum potholing coordination and geodetic mapping of buried infrastructure.",
    tag: "ASCE 38-02 Compliant"
  },
  {
    title: "3D Machine Guidance",
    desc: "Building contractor 3D surface files from CAD drawings for automated earthmoving, grading verification, and volume takeoffs.",
    tag: "Trimble / Topcon"
  }
];

export const Capabilities = () => (
  <section id="capabilities" className="py-24 bg-slate-ground border-b border-stone-200" data-testid="capabilities-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mb-16">
        <h2 className="text-xs font-bold uppercase tracking-widest text-amber-800 mb-2">Engineering &amp; Survey Disciplines</h2>
        <p className="font-display text-3xl sm:text-4xl font-bold text-stone-950">Field-Verified Professional Services</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((s, i) => (
          <div key={s.title} className="p-6 bg-white rounded-xl border border-stone-200 shadow-sm flex flex-col justify-between hover:shadow-md transition-shadow" data-testid={`capability-card-${i + 1}`}>
            <div>
              <h3 className="text-base font-bold text-stone-900 mb-2">{s.title}</h3>
              <p className="text-xs text-stone-600 leading-relaxed mb-4">{s.desc}</p>
            </div>
            <span className="text-[11px] font-bold text-amber-800 bg-amber-50 px-2.5 py-1 rounded w-fit">{s.tag}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
